module.exports = __webpack_public_path__ + "static/media/formatRates.c20bb4b2.png";